<template>
  <div class="WordSection1" style="layout-grid:15.6pt">
    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
    <span lang="EN-US" style='font-size:18.0pt;font-family:"Arial",sans-serif'
        >GF-5 Satellite</span
      >
    </p>
    <hr class="divider" />

    <p
      class="MsoNormal"
      align="center"
      style="text-align:center;mso-pagination:widow-orphan;
background:white"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:
"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt;
mso-no-proof:yes'
        ><!--[if gte vml 1
          ]><v:shapetype
            id="_x0000_t75"
            coordsize="21600,21600"
            o:spt="75"
            o:preferrelative="t"
            path="m@4@5l@4@11@9@11@9@5xe"
            filled="f"
            stroked="f"
          >
            <v:stroke joinstyle="miter" />
            <v:formulas>
              <v:f eqn="if lineDrawn pixelLineWidth 0" />
              <v:f eqn="sum @0 1 0" />
              <v:f eqn="sum 0 0 @1" />
              <v:f eqn="prod @2 1 2" />
              <v:f eqn="prod @3 21600 pixelWidth" />
              <v:f eqn="prod @3 21600 pixelHeight" />
              <v:f eqn="sum @0 0 1" />
              <v:f eqn="prod @6 1 2" />
              <v:f eqn="prod @7 21600 pixelWidth" />
              <v:f eqn="sum @8 21600 0" />
              <v:f eqn="prod @7 21600 pixelHeight" />
              <v:f eqn="sum @10 21600 0" />
            </v:formulas>
            <v:path
              o:extrusionok="f"
              gradientshapeok="t"
              o:connecttype="rect"
            />
            <o:lock v:ext="edit" aspectratio="t" /> </v:shapetype
          ><v:shape
            id="图片_x0020_1"
            o:spid="_x0000_i1025"
            type="#_x0000_t75"
            style="width:375pt;height:225pt;visibility:visible;mso-wrap-style:square"
          >
            <v:imagedata src="GF5.files/image001.png" o:title="" /> </v:shape><!
        [endif]--><img
          width="500"
          height="300"
          src="../../assets/gf5sat.png"
          v:shapes="图片_x0020_1"
        /></span
      ><span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
        ><o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white;text-align:left"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >GF-5 satellite was successfully launched on May 9, 2018. It is the
        first satellite observing land and atmosphere simultaneously in the
        world. The Ministry of Natural Resources of China is its main user.<o:p
        ></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white;text-align:left;"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >For the first time, the GF-5 satellite carried six payloads, including
        atmospheric trace gas differential optical absorption spectrometer,
        major greenhouse atmospheric gas detector, Multi-angle Polarization
        atmospheric detector, very high resolution infrared atmospheric
        environment detector, visible short-wave infrared hyperspectral imager
        and full-spectrum spectral imager, which can monitor atmospheric
        aerosol, sulfur dioxide and dioxide. nitrogen, carbon dioxide, methane,
        water blooms, water quality, nuclear power plant drainage temperature,
        land vegetation, straw burning, urban heat island and other
        environmental factors.<o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      style="text-indent:24.0pt;line-height:21.0pt;mso-pagination:
widow-orphan;background:white;text-align:left;"
    >
      <span
        lang="EN-US"
        style='mso-bidi-font-size:10.5pt;
font-family:"微软雅黑",sans-serif;mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:
0pt'
        >The visible short-wave infrared hyperspectral camera boarding the GF-5
        satellite is the first hyperspectral camera in the world, which features
        both wide coverage and wide spectral band. 330 spectral channels can be
        obtained in the spectral range from visible to short-wave infrared
        (400-2500 nm) with 60 km swath at 30 m spatial resolution, the spectral
        range is nearly 9 times wider than ordinary cameras, and the number of
        spectral channels is nearly 100 times larger than ordinary cameras. The
        spectral resolution in visible is 5 nanometers. They can effectively
        detect inland water bodies, land surface ecological environment, eroded
        minerals, rock and mineral categories, and provide good quality, high
        reliability of hyperspectral data for environmental monitoring, resource
        exploration, disaster prevention and mitigation and other
        industries.<o:p></o:p
      ></span>
    </p>

    <p
      class="MsoNormal"
      align="left"
      style="text-align:left;mso-pagination:widow-orphan;
background:white"
    >
      <b
        ><span
          lang="EN-US"
          style='font-size:12.0pt;font-family:"微软雅黑",sans-serif;
mso-bidi-font-family:宋体;color:#333333;mso-font-kerning:0pt'
          >Sensor technical parameters<o:p></o:p></span
      ></b>
    </p>

    <table
      class="MsoNormalTable"
      border="1"
      cellspacing="0"
      cellpadding="0"
      width="820"
      style="width:95%;border-collapse:collapse;border:none;mso-border-alt:solid #DDDFE4 .75pt;
 mso-yfti-tbllook:1184"
    >
      <thead>
        <tr style="mso-yfti-irow:0;mso-yfti-firstrow:yes">
          <td
            style="border:solid #DDDFE4 1.0pt;mso-border-alt:solid #DDDFE4 .75pt;
   background:#C1CCE4;padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
                  >Item<o:p></o:p></span
              ></b>
            </p>
          </td>
          <td
            colspan="2"
            style="border:solid #DDDFE4 1.0pt;border-left:none;mso-border-left-alt:
   solid #DDDFE4 .75pt;mso-border-alt:solid #DDDFE4 .75pt;background:#C1CCE4;
   padding:9.0pt 0cm 9.0pt 0cm"
          >
            <p
              class="MsoNormal"
              align="center"
              style="text-align:center;line-height:10.5pt;
   mso-pagination:widow-orphan"
            >
              <b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:
   10.5pt;font-family:宋体;mso-bidi-font-family:宋体;color:black;mso-color-alt:
   windowtext;mso-font-kerning:0pt"
                  >Parameter</span
                ></b
              ><b
                ><span
                  lang="EN-US"
                  style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:宋体;
   mso-font-kerning:0pt"
                  ><o:p></o:p></span
              ></b>
            </p>
          </td>
        </tr>
      </thead>
      <tr style="mso-yfti-irow:1">
        <td
          rowspan="3"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Atmospheric trace gases differential optical absorption
              spectrometer<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">EMI</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >240</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >315 nm<br />
                311</span
              >～<span lang="EN-US"
                >403 nm<br />
                401</span
              >～<span lang="EN-US"
                >550 nm<br />
                545</span
              >～<span lang="EN-US"
                >710 nm<br style="mso-special-character:line-break"/>
                <o:p
                ></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:2">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.3</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US">0.5 nm<o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:3">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spatial resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >48</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">Trajectory direction </span>）<span
                lang="EN-US"
                >* 13 km</span
              >（<span lang="EN-US">Along-track direction </span>）<span
                lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:4">
        <td
          rowspan="3"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Major greenhouse atmospheric gas detector<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">GMI</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Central wavelength<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.765 <span class="SpellE">μm</span><br />
              1.575 <span class="SpellE">μm</span><br />
              1.65 <span class="SpellE">μm</span><br />
              2.05 <span class="SpellE">μm</span
              ><br style="mso-special-character:line-break"/>
              <o:p
              ></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:5">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.759</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.769 <span class="SpellE">μm</span><br />
                1.568</span
              >～<span lang="EN-US"
                >1.583 <span class="SpellE">μm</span><br />
                1.642</span
              >～<span lang="EN-US"
                >1.658 <span class="SpellE">μm</span><br />
                2.043</span
              >～<span lang="EN-US"
                >2.058 <span class="SpellE">μm</span
                ><br style="mso-special-character:line-break"/>
                <o:p
                ></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:6">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.6 cm<br />
              0.27 cm<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:7">
        <td
          rowspan="2"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Multi-angle polarization atmospheric detector<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">DPC</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >433</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >453 nm<br />
                480</span
              >～<span lang="EN-US">500 nm</span>（<span lang="EN-US">P</span
              >）<span lang="EN-US"
                ><br />
                555</span
              >～<span lang="EN-US"
                >575 nm<br />
                660</span
              >～<span lang="EN-US">680 nm</span>（<span lang="EN-US">P</span
              >）<span lang="EN-US"
                ><br />
                758</span
              >～<span lang="EN-US"
                >768 nm<br />
                745</span
              >～<span lang="EN-US"
                >785 nm<br />
                845</span
              >～<span lang="EN-US">885 nm</span>（<span lang="EN-US">P</span
              >）<span lang="EN-US"
                ><br />
                900</span
              >～<span lang="EN-US"
                >920 nm<br style="mso-special-character:line-break"/>
                <o:p
                ></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:8">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spatial resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >≥3.5 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:9">
        <td
          rowspan="2"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Atmospheric Infrared Ultra-spectral Sounder<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">AIUS</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >750</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US">4100 cm</span>（<span lang="EN-US">2.4</span
              >～<span lang="EN-US">13.3 <span class="SpellE">μm</span></span
              >）<span lang="EN-US"><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:10">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.03 cm<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:11">
        <td
          rowspan="4"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Atmospheric visible-shortwave infrared Hyperspectral Imager<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">AHSI</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.4</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >2.5 <span class="SpellE">μm</span><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:12">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spatial resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >30 m<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:13">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Swath width<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >60 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:14">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >VNIR</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >：<span lang="EN-US"
                >5 nm<br />
                SWIR</span
              >：<span lang="EN-US">10 nm<o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:15">
        <td
          rowspan="3"
          style="border:solid #DDDDDD 1.0pt;border-top:none;mso-border-top-alt:
  solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Full-spectrum spectral imager<br /> </span
            ><span
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">VIMS</span>）<span lang="EN-US"
                ><o:p></o:p></span
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spectral range<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >0.45</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >～<span lang="EN-US"
                >0.52 <span class="SpellE">μm</span><br />
                0.52</span
              >～<span lang="EN-US"
                >0.60 <span class="SpellE">μm</span><br />
                0.62</span
              >～<span lang="EN-US"
                >0.68 <span class="SpellE">μm</span><br />
                0.76</span
              >～<span lang="EN-US"
                >0.86 <span class="SpellE">μm</span><br />
                1.55</span
              >～<span lang="EN-US"
                >1.75 <span class="SpellE">μm</span><br />
                2.08</span
              >～<span lang="EN-US"
                >2.35 <span class="SpellE">μm</span><br />
                3.50</span
              >～<span lang="EN-US"
                >3.90 <span class="SpellE">μm</span><br />
                4.85</span
              >～<span lang="EN-US"
                >5.05 <span class="SpellE">μm</span><br />
                8.01</span
              >～<span lang="EN-US"
                >8.39 <span class="SpellE">μm</span><br />
                8.42</span
              >～<span lang="EN-US"
                >8.83 <span class="SpellE">μm</span><br />
                10.3</span
              >～<span lang="EN-US"
                >11.3 <span class="SpellE">μm</span><br />
                11.4</span
              >～<span lang="EN-US"
                >12.5 <span class="SpellE">μm</span
                ><br style="mso-special-character:line-break"/>
                <br
                  style="mso-special-character:line-break"/>
                <o:p
                ></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:16">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Spatial resolution<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >20 m</span
            ><span
              style="mso-bidi-font-size:10.5pt;
  font-family:宋体;mso-bidi-font-family:宋体;mso-font-kerning:0pt"
              >（<span lang="EN-US">0.45</span>～<span lang="EN-US"
                >2.35 <span class="SpellE">μm</span></span
              >）<span lang="EN-US"
                ><br />
                40 m</span
              >（<span lang="EN-US">3.5</span>～<span lang="EN-US"
                >12.5 <span class="SpellE">μm</span></span
              >）<span lang="EN-US"><o:p></o:p></span
            ></span>
          </p>
        </td>
      </tr>
      <tr style="mso-yfti-irow:17;mso-yfti-lastrow:yes">
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >Swath width<o:p></o:p
            ></span>
          </p>
        </td>
        <td
          style="border-top:none;border-left:none;border-bottom:solid #DDDDDD 1.0pt;
  border-right:solid #DDDDDD 1.0pt;mso-border-top-alt:solid #DDDDDD .75pt;
  mso-border-left-alt:solid #DDDDDD .75pt;mso-border-alt:solid #DDDDDD .75pt;
  padding:6.0pt 4.5pt 6.0pt 4.5pt"
        >
          <p
            class="MsoNormal"
            align="center"
            style="text-align:center;mso-pagination:widow-orphan"
          >
            <span
              lang="EN-US"
              style="mso-bidi-font-size:10.5pt;font-family:宋体;mso-bidi-font-family:
  宋体;mso-font-kerning:0pt"
              >60 km<o:p></o:p
            ></span>
          </p>
        </td>
      </tr>
    </table>

    <p class="MsoNormal">
      <span lang="EN-US"><o:p>&nbsp;</o:p></span>
    </p>
  </div>
</template>
